<template>
  <div class="collEdit">
    <a-modal v-model="modalVisible" title="添加回款记录" width="797px" centered>
      <div class="collection-add">
        <a-form-model ref="addForm" :model="form" hideRequiredMark>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="是否回款到分期">
                <a-radio-group button-style="solid" v-model="form.is_payee_for_loan">
                  <a-radio-button :value="1">
                    是
                  </a-radio-button>
                  <a-radio-button :value="0">
                    不是
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="还款金额" prop="fee">
                <a-input v-model="allmoney" placeholder='请输入还款金额' style="width: 210px;" disabled></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="回款时间" prop="time">
                <a-date-picker v-model="form.time" placeholder="请选择" valueFormat="YYYY-MM-DD"  style="width: 210px;" format="YYYY-MM-DD"   />
              </a-form-model-item>
            </a-col>
          </a-row>
          <p class="s-tit">还款构成（选填）</p>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="本金">
                <a-input type="text" placeholder="请输入" v-model='form.list[0].fee' style="width: 210px;" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="利息">
                <a-input v-model='form.list[5].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="保全费">
                <a-input v-model='form.list[6].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="诉讼费">
                <a-input v-model='form.list[1].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="公告费">
                <a-input v-model='form.list[2].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="律师费">
                <a-input v-model='form.list[3].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="差旅费">
                <a-input v-model='form.list[8].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="上诉费">
                <a-input v-model='form.list[7].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="其他">
                <a-input v-model.trim="form.list[4].fee" placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="银行结清款">
                <a-input v-model='form.list[9].fee' placeholder='请输入' style="width: 210px;"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="备注">
                <div class="textarea">
                  <textarea v-model='form.comment' maxlength="500"></textarea>
                  <div class="bot">{{form.comment.length}}/500</div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div slot="footer" class="modal-footer">
        <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="collectionConfirm">
          <a-button type="primary">提交</a-button>
        </a-popconfirm>
        <a-button type="primary" class="cancel" @click="modalVisible=false;">取消</a-button>
      </div>
    </a-modal>
    <div class="charli">
      <div class="h2">基本信息</div>
      <div class="tp">
        <a-row style="margin-bottom:20px;">
          <a-col :span='10'>
            <label>债务人：</label>
            <span>{{info.realname}}</span>
          </a-col>
          <a-col :span='10'>
            <label>债务人证件号码：</label>
            <span>{{info.chinaid}}</span>
          </a-col>
          <a-col :span='4'>
            <label>联系方式：</label>
            <span>{{info.phone}}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span='10'>
            <label>户籍所在地：</label>
            <span>{{info.citys}}</span>
          </a-col>
          <a-col :span='10'>
            <label>经常居住地：</label>
            <span>{{info.dwell}}</span>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="charli">
      <div class="h2">案件回款
        <router-link :to='{"name":"AmountDetails",query:{id:$route.params.id}}' target='_blank' v-if='$common.AUTH("payee:add")'>
          <a-button type="primary" icon='plus'>添加回款 </a-button>
        </router-link>

      </div>
      <div class="fqTable">

        <div class="chbox">
          <a href="javascript:void(0);" v-for='(i,index) in causeList' :key='index' :class='{"cur":index==useIndex}' @click='seeCause(index)'>案件 {{i.sort}}</a>
        </div>
        <div class="h3">案件信息</div>
        <a-row class="rows">
          <a-col :span='3' style="display:flex;">
            <label>录入时间：</label>
            <div class="span">{{causeList[useIndex].create_time | yearFormat}}</div>
          </a-col>
          <a-col :span='4' style="display:flex;">
            <label>原告：</label>
            <div class="span" v-if="causeList[useIndex].accuser">
              <Normap :tit='causeList[useIndex].accuser.title'></Normap>
            </div>
          </a-col>
          <a-col :span='4' style="display:flex;">
            <label>案号：</label>
            <div class="span">
              <Normap :tit='causeList[useIndex].no'></Normap>
            </div>
          </a-col>
          <a-col :span='2' style="display:flex;">
            <label>案件：</label>
            <div class="span">案件{{causeList[useIndex].sort}}</div>
          </a-col>
          <a-col :span='4' style="display:flex;">
            <label>案件进度：</label>
            <div class="span" v-if="causeList[useIndex].step && causeList[useIndex].step.length>0">{{causeList[useIndex].step[0].title}}</div>
          </a-col>
          <a-col :span='7' style="display:flex;">
            <label>管辖法院：</label>
            <div class="span">{{causeList[useIndex].court}}</div>
          </a-col>
        </a-row>
        <div class="h3">
          回款记录
          <a-button type="primary" icon='plus' ghost @click='addHis' v-if='$common.AUTH("credit:payee:add")'>添加回款记录</a-button>
        </div>
        <div class="tablelist">
          <table class="table">
            <thead>
              <td width="120">回款录入时间</td>
              <td>回款日期</td>
              <td>回款小计</td>
              <td>本金</td>
              <td>利息</td>
              <td>诉讼费</td>
              <td>保全费</td>
              <td>公告费</td>
              <td>上诉费</td>
              <td>律师费</td>
              <td>差旅费</td>
              <td>其他</td>
              <td>银行结清款</td>
              <td width='140'>操作</td>
            </thead>
            <tbody>
              <tr v-for='(i,index) in list' :class="{'isover':i.cancel==1}">
                <td>{{i.create_time | yearFormat}}</td>
                <td>
                  <span v-if="i.time">{{i.time.slice(0,10)}}</span>
                </td>
                <td>{{i.fee | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,8) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,9) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,1) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,3) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,2) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,10) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,4) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,5) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,7) | showYuan}}</td>
                <td>{{rNumVal(i.fee_list,11) | showYuan}}</td>
                <td>
                  <span >
                    <a href='javascript:void(0)' style="height:24px;" @click='cx(i.id,index)' v-if='i.cancel==0 && $common.AUTH("payee:del")'>删除</a>
                    <span v-else>已删除</span>
                    <span class="line"></span>
                    <a href="javascript:void(0);" @click='seeD(i)' v-if='i.comment'>查看备注</a>
                    <span v-else>暂无备注</span>
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td><b>总计</b></td>
                <td></td>
                <td v-for="i in collAll">{{i | showYuan}}</td>
                <td>-</td>
              </tr>
            </tfoot>
          </table>
          <div class="pages">
            <a-pagination v-model="smform.page" show-quick-jumper :total="total" show-less-items :pageSize='5' @change='turnpage' :show-total="total => `小计 ${total} `" />
          </div>
        </div>
      </div>
    </div>
    <div class="charli" style="padding-bottom:20px;">
      <div class="h2">回款合计</div>
      <div class="smli">
        <div class="litp">
          <div class="span">
            <label>已还款金额：</label>
            <span>{{causeList[useIndex].payeeSum | showYuan}}元</span>
          </div>
          <div class="span">
            <label>最新还款日：</label>
            <span v-if='causeList[useIndex].payees.length>0'>{{causeList[useIndex].payees[causeList[useIndex].payees.length-1].time  | yearFormat}}</span>
          </div>
        </div>
        <div class="mainbox">
          <div class="cell">
            <div class="span" v-for='(k,inde) in px(causeList[useIndex].payeeGroupList)'>{{k.type_title}}：{{k.fee | showYuan}}元</div>
          </div>
        </div>
      </div>
      <div class="smli">
        <div class="litp">
          <div class="span">
            <label>未还款金额：</label>
            <!-- <span>{{notP(Allfree(causeList[useIndex].credit)*100,causeList[useIndex].payeeSum) | showYuan}}元</span> -->
            <span> {{(causeList[useIndex].creditSum-causeList[useIndex].payeeSum) | showYuan}}</span>
          </div>
        </div>
        <div class="mainbox">
          <div class="cell">
            <div class="span" v-if="k.type!=11" v-for='(k,inde) in px(noGroupList(causeList[useIndex].payeeGroupList,rPropo(causeList[useIndex].credit)))'>{{k.type_title}}：{{k.fee | showYuan}}元</div>
          </div>
        </div>
      </div>
      <!-- <div class="smli">
        <div class="litp">
          <div class="span">
            <label>分期总额：</label>
            <span>{{causeList[useIndex].loanSum | showYuan}}元</span>
          </div>
          <div class="span">
            <label>录入日期：</label>
            <span v-if='causeList[useIndex].loan.length>0'>{{causeList[useIndex].loan[0].create_time  | yearFormat}}</span>
          </div>
        </div>
        <div class="mainbox">
          <div class="cell">
            <div class="span" v-for='(k,inde) in px(causeList[useIndex].loanGroupList)'>{{k.type_title}}：{{k.fee | showYuan}}元
            </div>
          </div>
        </div>
      </div> -->
      <div class="smli">
        <div class="litp">
          <div class="span">
            <label>已确认债权合计：</label>
            <span>{{causeList[useIndex].creditSum | showYuan}}元</span>
          </div>
          <!-- <div class="span">
            <label>确认日期：</label>
            <span>2021-11-16</span> 
          </div>-->
        </div>
        <div class="mainbox">
          <div class="cell">
            <div class="span" v-for='(k,inde) in npx(causeList[useIndex].credit)' v-if="k.type!=11">{{k.type_title}}：{{k.fee | showYuan}}元</div>
          </div>
        </div>
      </div>
    </div>
    <div class="charli" style="padding-bottom:20px;" v-if='$common.AUTH("payee:Log")'>
      <div class="h2" style="border:0 none;">操作记录</div>
      <div class="ztable">
        <table class="table" v-if='hislist[0].list.length>0'>
          <thead>
            <td>时间</td>
            <td>操作人员</td>
            <td>操作记录</td>
          </thead>
          <tbody>
            <tr v-for='i in hislist[0].list'>
              <td>{{i.time}}</td>
              <td>{{i.manager || ''}}</td>
              <td>{{i.title}}</td>
            </tr>
          </tbody>
        </table>
        <table class="table" v-if='hislist[1].list.length>0'>
          <thead>
            <td>时间</td>
            <td>操作人员</td>
            <td>操作记录</td>
          </thead>
          <tbody>
            <tr v-for='i in hislist[1].list'>
              <td>{{i.time}}</td>
              <td>{{i.manager || ''}}</td>
              <td>{{i.title}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pages" style="padding-right:20px;">
        <a-pagination v-model="hmform.page" show-quick-jumper :total="totals" show-less-items @change='nturn' :show-total="totals => `小计 ${totals} `" />
      </div>
    </div>
  </div>
</template>
<script>
import Propo from '../payback/step.json'
const Proposition=[...Propo,{
    "tit": "银行结清款",
    "type": "11"
}]
import { cxPost } from '@/server/api'
import { addCollection, paylog, hkDetails } from '@/server/collection'
import {yearFormat} from "@/assets/js/formData";
const formKey = {
  cause_id: '',
  fee: '',
  time: '',
  is_payee_for_loan: null,
  comment: '',
  list: [
    {
      type: 8, fee: ''
    },
    {
      type: 1,
      fee: ''
    },
    {
      type: 2,
      fee: ''
    },
    {
      type: 4,
      fee: ''
    },
    {
      type: 7,
      fee: ''
    },
    {
      type: 9,
      fee: ''
    },
    {
      type: 3,
      fee: ''
    },
    {
      type: 10,
      fee: ''
    },
    {
      type: 5,
      fee: ''
    },
    {
      type: 11,
      fee: ''
    }
  ]
}
export default {
  data() {
    return {
      collAll: [],
      totals: 0,
      rules: {},
      form: JSON.parse(JSON.stringify(formKey)),
      modalVisible: false,
      useIndex: 0,
      hislist: {
        0: { list: [] },
        1: { list: [] }
      },
      smform: {
        page: 1,
      },
      hmform: {
        page: 1,
      },
      info: {},
      causeList: [
        { payees: [{}], loan: [{}] }
      ]
    }
  },
  created() {
    this.init()

  },
  computed: {
    allmoney() {
      let arr = this.form.list.filter(ele => { return ele.fee > 0 }).map(ele => { return ele.fee * 1 })
      if (arr.length > 0) {
        return arr.reduce((prev, next) => {
          return prev + next
        }).toFixed(2)
      } else {
        return 0
      }
    },
    // 0, 1, 2, 3, 4  
    // 5, 6, 7, 8, 9
    list() {
      const allList = JSON.parse(JSON.stringify(this.causeList[this.useIndex].payees))
      let arr = [], brr = []
      allList.map(ele => {
        if (ele.cancel == 0) {
          arr.push(ele)
        } else {
          brr.push(ele)
        }
      })
      let slist = [...arr, ...brr]
      if (this.smform.page == 1) {
        return slist.filter((ele, index) => { return index < 5 })
      } else {
        return slist.filter((ele, index) => { return index >= (this.smform.page - 1) * 5 && index < this.smform.page * 5 })
      }

    },
    total() {
      return this.causeList[this.useIndex].payees.length
    }
  },
  methods: {
    yearFormat,
    nturn(val) {
      this.hmform.page = val;
      this.getHis()
    },
    getCollList(list) {   //计算合计
      const getAll = (type) => {
        let i = 0;
        list.map(ele => {
          if (ele.cancel == 0) {
            ele.fee_list.map(s => {
              if (s.type == type) {
                i += s.fee
              }
            })
          }
        })
        return i
      }

      const getFee = () => {    //合计
        let i = 0;
        list.map(ele => {
          if (ele.cancel == 0) {
            i += ele.fee
          }
        })
        return i
      }
      let all = [8, 9, 1, 3, 2, 10, 4, 5, 7].map(ele => {
        return getAll(ele)
      })
      all.unshift(getFee())
      this.collAll = all
    },
    getHis() {
      paylog(Object.assign({ cause_id: this.causeList[this.useIndex].id }, this.hmform)).then(res => {
        let arr = {
          0: { list: [] },
          1: { list: [] }
        }
        res.list.map((ele, index) => {
          if (index < 5) {
            arr[0].list.push(ele)
          } else {
            arr[1].list.push(ele)
          }
        })
        this.totals = res.count
        this.hislist = arr
      })
    },
    seeD(item) {
      this.$modal.info({
        title: '备注',
        footer: null,
        content: item.comment,
      });
    },
    addHis() {
      let form = JSON.parse(JSON.stringify(formKey))
      form.cause_id = this.causeList[this.useIndex].id
      this.form = form
      this.modalVisible = true

    },
    cx(id, index) {
      this.$modal.confirm({
        content: '确认删除？',
        onOk: () => {
          cxPost({ id: id }).then(e => {
            this.$message.success("已提交审核")
            this.causeList[this.useIndex].payees[index].cancel = 1
          })
        }
      });
    },
    notP(has, all) {
      return (all - has)
    },
    Allfree(Arr) {
      if (Arr) {
        let i = 0;
        Arr.map(e => {
          i += e.fee / 100 * 1
        })
        return i
      }
    },
    noGroupList(payeeGroupList, Allcredit) {    //未还款
      if (payeeGroupList && Allcredit) {
        let Arr = []
        payeeGroupList.map(ele => {
          Allcredit.map(element => {
            if (ele.type == element.type) {
              Arr.push({
                fee: element.fee - ele.fee,
                type: ele.type,
                type_title: ele.type_title
              })
            }
          })
        })
        return Arr
      }
    },
    px(Arr, s) {
      let newArr = []
      if (Arr) {
        Proposition.map(ele => {
          let s = Arr.find(s => { return s.type == ele.type })
          if (ele.type != 6) {
            newArr.push({
              type_title: ele.tit,
              type: ele.type,
              fee: s ? s.fee : 0
            })
          }
        })
        return newArr
      }
    },
    npx(Arr) {
      let newArr = []
      if (Arr) {
        Proposition.map(ele => {
          let s = Arr.find(s => { return s.type == ele.type })
          newArr.push({
            type_title: ele.tit,
            type: ele.type,
            fee: s ? s.fee : 0
          })
        })
        return newArr
      }
    },
    rPropo(Arr) {
      let newArr = []
      if (Arr) {
        Object.keys(Proposition).map(item => {
          let isInclude = Arr.some(it => {
            return it.type == item
          })
          if (isInclude == false) {
            newArr.push({
              type_title: Proposition[item],
              type: item * 1,
              fee: 0
            })
          } else {
            newArr.push(Arr.filter(ele => { return ele.type == item })[0])
          }
        })
        return newArr
      }
    },
    rNumVal(fee_list, t) {
      if (fee_list) {
        let fee = fee_list.filter(ele => { return ele.type == t })
        if (fee.length > 0) {
          return fee[0].fee
        } else {
          return 0
        }
      }
    },
    seeCause(index) {
      this.useIndex = index;
      this.getCollList(this.causeList[this.useIndex].payees)
    },
    init() {
      const id = this.$route.params.id
      hkDetails({ debtor_id: id }).then(e => {
        this.causeList = e.info.cause
        this.getHis()
        this.seeCause(0)
      })
      this.$Ajax({
        url: 'debtor/info',
        type: 'get',
        data: { id: id },
        success: (res) => {
          let e = res.info;
          this.audit = res.info.audit;
          this.info = {
            citys: e.province + e.city + e.area + e.addr,
            dwell: e.dwell_province ? e.dwell_province + e.dwell_city + e.dwell_area + e.dwell_addr : e.province + e.city + e.area + e.addr,
            chinaid: e.chinaid,
            realname: e.realname,
            phone: e.phone
          }

        }
      })
    },
    collectionConfirm() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.form))
          let arr = []
          if (!obj.time) {
            this.$message.error("请选择还款日期")
            return false;
          }
          if (obj.is_payee_for_loan === null) {
            this.$message.error("请选择是否回款到分期")
            return false;
          }
          // if (obj.list[0].fee == 0) {
          //   this.$message.error("本金不能为空")
          //   return false;
          // }
          obj.list.forEach((ele) => {
            if (ele.fee) {
              ele.fee = (ele.fee * 100).toFixed(0)
              arr.push(ele)
            }
          })
          obj.list = arr
          if (arr.length == 0) {
            this.$message.error("还款构成金额相加必须等于还款金额")
            return false;
          }
          const allPrice = arr.map(ele => { return ele.fee * 1 }).reduce((s, a) => {
            return s + a
          })
          obj.fee = allPrice
          obj.list = obj.list.filter(ele => {
            return ele.fee > 0
          })
          addCollection(obj).then((res) => {
            this.$message.success({ content: '添加成功' });
            setTimeout(e => {
              window.history.go(0)
            }, 500)
          })
        }
        else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    turnpage(val) {
      this.smform.page = val;
    },
  }
}
</script>
<style lang="less" scoped>
.rows {
  label {
    white-space: nowrap;
  }
  .span {
    width: 70%;
  }
}
.tablelist {
  .isover td {
    opacity: 0.4;
  }
  tbody {
    td {
      height: 58px;
    }
    tr {
      border-top: 0 none;
      border-bottom: 1px solid #efefef;
    }
  }
  tfoot {
    td {
      height: 64px;
      font-size: 14px;
      font-weight: bold;
      color: #0e2949;
    }
  }
  .pages {
    padding: 20px 0;
  }
}
label {
  color: #0e2949;
}
.textarea {
  width: 572px;
  height: 132px;
  border-radius: 4px;
  border: 1px solid #dbdcde;
  padding: 10px;
  margin-top: 10px;
  textarea {
    width: 100%;
    height: 84px;
    line-height: 21px;
    border: 0 none;
  }
  .bot {
    text-align: right;
    font-size: 14px;
    color: rgba(162, 163, 165, 0.5);
    line-height: 20px;
  }
}
.collEdit {
  .charli {
    background: #fff;
    margin-bottom: 10px;
    .h2 {
      line-height: 62px;
      font-size: 16px;
      font-weight: bold;
      padding: 0 20px;
      color: #0e2949;
      border-bottom: 1px solid #efefef;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .tp {
      padding: 20px;
    }
    .fqTable {
      padding: 0 20px;
    }
    .chbox {
      border-bottom: 1px solid #efefef;
      line-height: 50px;
      a {
        color: #333;
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        transition-duration: 500ms;
      }
      a:hover,
      .cur {
        color: #1d8bfe;
      }
    }
    .h3 {
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: bold;
      color: #0e2949;
    }
  }
  .pages {
    text-align: right;
  }
  .smli {
    margin-top: 10px;
    padding: 0 20px;
    .litp {
      line-height: 40px;
      display: flex;
      .span {
        width: 224px;
        font-size: 14px;
        color: #0e2949;
        span {
          font-weight: 500;
          color: #0e2949;
        }
      }
    }
    .mainbox {
      width: 100%;
      height: 90px;
      background: #f6f8fc;
      padding: 20px 0 0 20px;
      .cell {
        display: flex;
        width: 1000px;
        display: flex;
        flex-wrap: wrap;
        .span {
          width: 200px;
          margin-bottom: 10px;
          font-size: 14px;
          color: #0e2949;
          line-height: 20px;
        }
      }
    }
  }
  .ztable {
    overflow: hidden;
    padding-left: 20px;
    // justify-content: space-between;
    table {
      float: left;
      margin-right: 20px;
      border: 1px solid #ebebeb;
      max-width: 48%;
      thead {
        td {
          text-align: center;
          padding: 0;
          border-right: 1px solid #ebebeb;
        }
      }
      tbody {
        tr {
          td {
            text-align: center;
            padding: 0;
            border-right: 1px solid #ebebeb;
          }
        }
      }
    }
  }
}
</style>